<template>
  <div></div>
</template>

<script>
  import ShopifyBuy from 'shopify-buy';

  export default {
    mounted() {
      ShopifyBuy.buildClient({
        accessToken: 'c532a34d42a102560faf84bbb93624f1',
        domain: 'powernine.myshopify.com',
        appId: '6',
      }).fetchRecentCart().then((c) => {
        c.clearLineItems();
      });
    },
  };
</script>



// WEBPACK FOOTER //
// ClearCart.vue?94710c22